import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

export const ConditionFieldLayoutLoading = (): JSX.Element => (
  <FlexBox
    as="li"
    padding="250 300"
    alignItems="center"
    justifyContent="center"
  >
    <Spinner size={20} />
  </FlexBox>
);
